export const PIXLIE_SUPPORT_EMAIL = 'team@brightforge.ltd';

export const pixlieSupportMailto = (subject = 'Pixlie Support') =>
  `mailto:${PIXLIE_SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
